export class ValidationError {
  constructor(public key?: string, public name?: string, public code?: string, public args?: Array<string>) {}
}
